import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function Button({
  children,
  className = '',
  onClick,
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-navy-dark bg-gold hover:bg-gold-hover rounded-full transition-colors duration-300 shadow-lg hover:shadow-xl w-full sm:w-auto text-center cursor-pointer';
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (href && href.startsWith('#')) {
      e.preventDefault();
      e.stopPropagation();
      const targetId = href.substring(1);
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
    if (onClick) onClick();
  };
  if (href) {
    const isExternal = href.startsWith('http');
    return <motion.a href={href} onClick={!isExternal ? handleClick as any : undefined} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={`${baseStyles} ${className}`} data-id="element-31">
        {children}
      </motion.a>;
  }
  return <motion.button onClick={handleClick as any} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${className}`} {...props} data-id="element-32">
      {children}
    </motion.button>;
}